<template>
    <Chart @getData="getData" :ifBK="false" :ifsquare="false">
        <template #v>
            <div class="row">
                <div class="col" v-for="(item, index) in data" :key="index">
                    <div>
                        <span class="left">{{ item.name }}</span>
                        <img src="../../assets/dongxiang/iconshuju.png" alt="" class="icon">
                        <span class="right en">{{ item.value }}</span>
                        <span class="right">{{ item.units }}</span>
                    </div>
                </div>
            </div>
        </template>
    </Chart>
</template>

<script>
import Chart from "./components/chart";
export default {
    name: "",
    data() {
        return {
            data: [],
        };
    },
    methods: {
        getData(x, y, times) {
            var url =
                this.urlobj.dx_jjfx +
                `?tableName=rlt_40year_item_value&times=${times}&itemid=3,1,10,46,8`;
            this.$get(url).then((res) => {
                let data = res.rows[0].data;
                if (data.length != 0) {
                    this.data = data;
                }
            });
        },
    },
    computed: {
        bigData() {
            return this.$store.state.bigData;
        },
    },
    watch: {
        bigData() {
            this.getData();
        },
    },
    created() {

    },
    components: {
        Chart,
    },
};
</script>

<style lang="less" scoped>
.row {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    position: relative;
    .col {
        box-shadow: 0px 0px 3px 3px #0d3b91 inset;
        line-height: 40px;
        border: 1px solid #17d1fe;
        border-radius: 12px;
        width: 19.8%;
        height: 80px;
        box-sizing: border-box;
        padding: 20px;
        .left {
            color: #a5a8b7;
            margin: 0 20px 0 0;
        }
        .en {
            font-size: 18px;
        }
        .right {
            color: #ffb600;
        }

        .icon {
            display: inline-block;
            width: 16px;
            height: 16px;
            margin: 0 4px 0 30px;
            // background-image: url('../../assets/images/epidemicForm/icon1.png'), linear-gradient(#ffb600, #ffb600);
            // background-blend-mode: darken;
            // background-size: cover;
        }
    }
    &::after {
        background-image: url("../../assets/dongxiang/right.png");
        position: absolute;
        content: "";
        display: block;
        right: -7px;
        top: -7px;
        width: 38px;
        height: 38px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    &::before {
        background-image: url("../../assets/dongxiang/left.png");
        position: absolute;
        content: "";
        display: block;
        left: -7px;
        top: -7px;
        width: 38px;
        height: 38px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
}
</style>
